module.exports = __webpack_public_path__ + "img/solution-icon-2.ec8f5b95.png";